import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["table", "link"]

  toggleRows() {
    var rows = $(this.tableTarget).find(".hidden-results")
    var link = $(this.linkTarget)

    if (rows.first().hasClass("hidden")) {
      rows.each(function () {
        $(this).removeClass("hidden")
      })

      link.text("Show less")
      return
    }

    rows.each(function (index) {
      $(this).addClass("hidden")
    })

    link.text("Show more")
  }
}
